const URL = 'mitra-pollings/';
const TRANSACTION_FEEDBACK_URL = `${URL}transaction-feedbacks`;
const TRANSACTION_FEEDBACK_REASON_URL = `${URL}transaction-feedback-reasons`;

export const updateTransactionFeedback = ($axios, id, payload) =>
  $axios.$patch(`${TRANSACTION_FEEDBACK_URL}/${id}`, payload);
export const getTransactionFeedbackReason = ($axios, params) =>
  $axios.$get(TRANSACTION_FEEDBACK_REASON_URL, { params });
